"use strict";

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

var clone = require('clone');

var tv4 = require('tv4');

var TableItemSchema = /*#__PURE__*/function () {
  function TableItemSchema(opt) {
    _classCallCheck(this, TableItemSchema);

    this.key = null;
    this.label = null;
    this.type = null;

    if (opt) {
      this.fillObject(clone(opt));
    }
  }

  _createClass(TableItemSchema, [{
    key: "fillObject",
    value: function fillObject(details) {
      this.key = details.key || null;
      this.label = details.label || 'Text';
      this.type = details.type || 'TEXT';
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, TableItemSchema.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'table-item-schema.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          details: {
            key: {
              type: 'string'
            },
            label: {
              type: 'string'
            },
            type: {
              type: 'string',
              "enum": ['TEXT', 'DATE', 'NUMBER']
            }
          }
        },
        required: Object.keys(this)
      };
    }
  }]);

  return TableItemSchema;
}();

module.exports = TableItemSchema;